import { render, staticRenderFns } from "./NoSubscriptionComponent.vue?vue&type=template&id=638467a8&"
import script from "./NoSubscriptionComponent.vue?vue&type=script&lang=js&"
export * from "./NoSubscriptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports